<template>
  <div>
    <p v-if="(doctor.gender || isConnecticut) && labels.gender"><strong>{{labels.gender}}</strong>: {{doctor.gender}}</p>
    <p v-if="(doctor.languagesSpoken || isConnecticut) && (labels.languageNonenglish || labels.spokenLanguage)"><strong>{{labels.languageNonenglish || labels.spokenLanguage}}</strong>:
      {{formatCommaList(doctor.languagesSpoken)}}
    </p>
    <p v-if="(doctor.education || isConnecticut) && labels.education"><strong>{{labels.education}}</strong>:
      {{doctor.education}}
    </p>
    <p v-if="!hideAcceptNewPatient && (labels.acceptingNewPatient || labels.acceptingNew)"><strong>{{labels.acceptingNewPatient || labels.acceptingNew}}</strong>: {{acceptingNewLabel}}</p>
    <DoctorDetailsList
      v-if="doctor.newPatientTypes && doctor.newPatientTypes.length > 0"
      :doctor="doctor"
      :labels="labels"
      dataKey="newPatientTypes"
      labelDetailsKey="newPatientDetails"
    />
    <p v-if="(doctor.credentialsAndCertifications || isConnecticut) && (labels.boardCertifications || labels.credentials)"><strong>{{labels.boardCertifications || labels.credentials}}</strong>:
      {{doctor.credentialsAndCertifications}}
    </p>
    <p v-if="(doctor.licenseNumber || isConnecticut) && (labels.stateLicense || labels.licenseNumber)"><strong>{{labels.stateLicense  || labels.licenseNumber}}</strong>: {{doctor.licenseNumber}}</p>
    <p v-if="(doctor.npiLicenseNumber || isConnecticut) && labels.npiNumber"><strong>{{labels.npiNumber}}</strong>: {{doctor.npiLicenseNumber}}</p>
    <p v-if="!labels?.hideTelehealth && labels.telehealthLabel"><strong>{{labels.telehealthLabel}}</strong>: {{ telehealthValue }}</p>
    <p v-if="(doctor.culturalCompetencyInd || isConnecticut) && labels.culturalCompetency"><strong>{{labels.culturalCompetency}}</strong>: {{doctor.culturalCompetencyInd}}</p>
    <DoctorDetailsList
      v-if="doctor.culturalCompetencyTypes && doctor.culturalCompetencyTypes.length > 0"
      :doctor="doctor"
      :labels="labels"
      dataKey="culturalCompetencyTypes"
      labelDetailsKey="culturalCompetencyDetails"
    />
    <!-- <p v-if="doctor.emailAddress">{{labels.email}}</strong>: {{doctor.emailAddress}}</p> -->
  </div>
</template>
<script lang="ts">
   import {defineComponent} from 'vue'
  import { Doctor, Provider } from '@/types'
  import { mapState } from 'vuex'
  import { formatCommaList } from '@/ts/helpers/search-providers.helpers.ts'
  import isConnecticut from '@/mixins/IsConnecticut.ts'
  import DoctorDetailsList from './DoctorDetailsList.vue'

  export default defineComponent({
    mixins: [isConnecticut],
    components: {
      DoctorDetailsList
    },
    props: {
      provider: {
        required: true,
        type: Object as () => Provider
      },
      doctor: {
        required: true,
        type: Object as () => Doctor
      },
      hideAcceptNewPatient: {
        default: false,
        type: Boolean
      },
      doctorDetailsLabel: {
        required: false,
        type: Object,
      }
    },
    computed: {
      acceptingNewLabel(): string|null {
        const acceptingNew = this.doctor!.acceptingNewPatients || ''
        return (
          this.$route.params.lang === 'es-us' && 
          acceptingNew.toLowerCase() === 'yes'
        ) ? 
          'Sí' : 
          this.doctor.acceptingNewPatients
      },
      telehealthValue() {
        const telehealth = this.doctor?.telehealthInd;
        
        if (telehealth?.toLowerCase() === 'yes') {
          return this.labels.telehealthYes;
        }
        return this.labels.telehealthDefault;
      },
      labels() {
      if (this.doctorDetailsLabel) {
        return this.doctorDetailsLabel;
      }
      return this.$store.state.globals.microsite.doctorLabels;
    },
    },
    methods: {
      formatCommaList
    }
  })
</script>
